<template>
  <div class='table-box'>
    <global-tag>
      <el-form
        :inline='true'
        :model='searchlist'
        class='demo-form-inline'
        size='mini'
      >
        <el-form-item label='角色名称:'>
          <el-input
            v-model='searchlist.name'
            placeholder='请输入角色名称'
          ></el-input>
        </el-form-item>
        <el-form-item label='状态:'>
          <el-select
            v-model='searchlist.useable'
            placeholder='请选择'
            style='width: 150px'
          >
            <el-option label='启用' :value='1'></el-option>
            <el-option label='禁用' :value='0'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' icon='el-icon-search' @click='searchlistdata'
          >查询
          </el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type='info' @click='searchlistReset'>重置</el-button>
        </el-form-item>
        <el-form-item></el-form-item>
      </el-form>
    </global-tag>
    <div class='three'>
      <el-button type='primary' size='mini' @click="showDialogForm(0, 'add')"
      >新增
      </el-button
      >
      <!-- <el-button
                        type="danger"
                        size="mini"
                        @click="deleteRows()"
                        >批量删除</el-button
                    > -->
      <el-button type='primary' size='mini' @click='typeModal = true'
      >角色新增管理
      </el-button
      >
    </div>
    <!-- 表格盒子 -->
    <div class='table_card'>
      <el-table
        :data='tableData'
        :header-cell-style="{ background: '#f8fafa' }"
        border
        highlight-current-row
        @selection-change='handleSelectionChange'
      >
        <el-table-column
          type='selection'
          align='center'
          width='100'
        ></el-table-column>
        <el-table-column
          align='center'
          prop='name'
          label='角色名称'
        ></el-table-column>

        <!-- <el-table-column align="center" prop="enname" label="角色标志"></el-table-column> -->
        <!-- <el-table-column align="center" prop="createDate" label="创建时间"></el-table-column> -->
        <el-table-column align='center' prop='useable' label='状态'>
          <template slot-scope='scope'>
            <!-- <el-switch v-model="scope.row.useable" v-permission="{sign:'xtsz:jsgl:ztxg'}" :active-value='1' :inactive-value='0'
                  @change="changeStatus(scope.row)">
              </el-switch> -->
            <el-switch
              v-model='scope.row.useable'
              :active-value='1'
              :inactive-value='0'
              @change='changeStatus(scope.row)'
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          align='center'
          prop='roleFeatures'
          label='角色特征'
        >
          <template slot-scope='scope'>
            <span v-if='scope.row.roleFeatures == 1'>标准</span>
            <span v-if='scope.row.roleFeatures == 2'>特殊</span>
          </template>
        </el-table-column>
        <el-table-column align='center' label='操作' fixed='right'>
          <template slot-scope='scope'>
            <el-tooltip
              class='item'
              effect='light'
              content='修改'
              placement='top-start'
            >
              <button
                class='iconfont icon-bianji3 tabBtn tabBtn-edit'
                @click="showDialogForm(scope.row.id, 'edit', scope.row.name)"
              ></button>
            </el-tooltip>
            <el-tooltip
              class='item'
              effect='light'
              content='权限分配'
              placement='top-start'
            >
              <button

                class='el-icon-s-tools tabBtn tabBtn-audit'
                @click="showDialogForm(scope.row.id, 'assign', scope.row.name)"
              ></button>
            </el-tooltip>
            <el-tooltip
              class='item'
              effect='light'
              content='授权数据'
              placement='top-start'
            >
              <button
                :disabled='scope.row.roleFeatures == 1 '
                style='font-size: 20px; cursor: pointer'
                class='el-icon-menu tabBtn tabBtn-detail'
                @click='showAuthorDialog(scope.row.id)'
              ></button>
            </el-tooltip>
            <el-tooltip
              class='item'
              effect='light'
              content='删除'
              placement='top-start'
            >
              <button
                class='iconfont icon-icon7 tabBtn tabBtn-delete'
                @click='showdeletepanduan(scope.row.id, scope.row.name)'
              ></button>
            </el-tooltip>
            <el-tooltip
              class='item'
              effect='light'
              content='查看'
              placement='top-start'
            >
              <button
                class='iconfont icon-chakan tabBtn tabBtn-detail'
                @click="showDialogForm(scope.row.id, 'detail', scope.row.name)"
              ></button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
        :page-size='pageConfig.pageSize'
        layout='total, prev, pager, next, jumper'
        @current-change='handleCurrentChange'
        :total='pageConfig.total'
      ></el-pagination>
    </div>
    <!-- 弹出框修改 -->
    <el-dialog
      :title='dialogTitle'
      :visible.sync='showDialog'
      width='500px'
      :before-close='clearadddata'
    >
      <el-form
        ref='dialogfrom'
        :rules='rules'
        :model='rowData'
        label-width='120px'
        size='mini'
      >
        <el-form-item label='角色名称:' prop='name'>
          <el-input
            v-model='rowData.name'
            :disabled='editDisable'
            placeholder='请输入角色名称'
          ></el-input>
        </el-form-item>
        <el-form-item label='角色标志:' prop='enname'>
          <el-input
            v-model='rowData.enname'
            :disabled='editDisable'
            placeholder='请输入英文字符，唯一'
          ></el-input>
        </el-form-item>
        <el-form-item label='角色特征:' prop='useable'>
          <el-radio-group :disabled='editDisable' v-model='rowData.roleFeatures'>
            <el-radio :label='1'>标准</el-radio>
            <el-radio :label='2'>特殊</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label='状态:' prop='useable'>
          <el-radio-group :disabled='editDisable' v-model='rowData.useable'>
            <el-radio :label='1'>启用</el-radio>
            <el-radio :label='0'>禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label='备注:' prop='remarks'>
          <el-input
            type='textarea'
            v-model='rowData.remarks'
            :disabled='editDisable'
            :rows='2'
            placeholder='请输入备注'
          ></el-input>
        </el-form-item>
      </el-form>
      <div class='boontbtn'>
        <el-button
          v-if='!editDisable'
          type='primary'
          size='small'
          style='margin: 0 30px'
          @click='saveadddata'
        >保存
        </el-button>
        <el-button type='info' size='small' @click='clearadddata'>关闭</el-button>
      </div>
    </el-dialog>

    <!-- 弹出框新增 -->
    <el-dialog
      title='新增角色管理'
      :visible.sync='typeModal'
      width='800px'
      :close-on-click-modal='false'
    >
      <div class='fisthang'>
        <el-form :inline='true' :model='searchlist' class='demo-form-inline' size='mini'>
          <el-form-item label='角色名称:' prop='name'>
            <el-input
              style='width: 500px'
              v-model='rowData.name'
              placeholder='请输入角色名称'
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type='primary' icon='el-icon-search' @click='addend'
            >确定
            </el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class='table_card' style="width: '1200px'">
        <el-table
          :data='tableData'
          :header-cell-style="{ background: '#f8fafa' }"
          border
          highlight-current-row
        >
          <el-table-column
            align='center'
            prop='postSort'
            label='序号'
            type='index'
          ></el-table-column>
          <el-table-column align='center' prop='name' label='角色名称'></el-table-column>
          <el-table-column align='center' prop='createTime' label='创建时间'>
            2021-4-20 15:40
          </el-table-column>
          <el-table-column align='center' label='操作' fixed='right'>
            <template slot-scope='scope'>
              <el-tooltip
                class='item'
                effect='light'
                content='查看'
                placement='top-start'
              >
                <button
                  class='iconfont icon-chakan tabBtn tabBtn-detail'
                  @click="lookcenter('查看', scope.row)"
                ></button>
              </el-tooltip>
              <el-tooltip
                class='item'
                effect='light'
                content='修改'
                placement='top-start'
              >
                <button
                  class='iconfont icon-bianji3 tabBtn tabBtn-edit'
                  @click="lookcenter('修改', scope.row)"
                ></button>
              </el-tooltip>
              <el-tooltip
                class='item'
                effect='light'
                content='删除'
                placement='top-start'
              >
                <button
                  class='iconfont icon-icon7 tabBtn tabBtn-delete'
                  @click='deleteItem(scope.row.id, scope.row.name)'
                ></button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页功能 -->
        <el-pagination
          :page-size='pageConfig.pageSize'
          layout='total, prev, pager, next, jumper'
          @current-change='handleCurrentChange'
          :total='pageConfig.total'
        ></el-pagination>
      </div>
    </el-dialog>

    <!-- 弹出查看修改 -->
    <el-dialog
      :title='dialogTitle'
      :visible.sync='typeModallook'
      width='800px'
      :close-on-click-modal='false'
    >
      <div class='fisthang'>
        <el-form :inline='true' :model='searchlist' class='demo-form-inline' size='mini'>
          <el-form-item label='角色名称:' prop='name'>
            <el-input
              :disabled="dialogTitle === '查看'"
              style='width: 600px'
              v-model='names'
              placeholder='请输入角色名称'
            ></el-input>
          </el-form-item>
        </el-form>
        <div class='boontbtn'>
          <el-button
            v-if="dialogTitle !== '查看'"
            type='primary'
            size='small'
            style='margin: 0 30px'
            @click='typeModallook = false'
          >
            确定
          </el-button>
          <el-button type='info' size='small' @click='typeModallook = false'
          >关闭
          </el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog title='权限分配' :visible.sync='showViewRight' width='900px'>
      <ViewRight ref='viewRight' :rowid='rowid' @func='dialogReturn'></ViewRight>
    </el-dialog>
    <!--    授权数据弹框-->
    <el-dialog
      title='授权数据'
      :close-on-click-modal='false'
      :visible.sync='authorDialogVisible'
      width='500px;'
      :before-close='onAuthorDialogClose'
    >
      <div style='display: flex'>
        <div style='width: 80px'>选择机构:</div>
        <el-tree
          ref='orgTree'
          :data='orgTree'
          show-checkbox
          node-key='orgId'
          default-expand-all
          check-strictly
          :props='defaultProps'
        >
        </el-tree>
      </div>
      <div
        style='
          margin-top: 15px;
          padding-top: 15px;
          display: flex;
          justify-content: flex-end;
          border-top: 1px solid #ccc;
        '
      >
        <el-button size='medium' @click='onAuthorDialogClose'>取消</el-button>
        <el-button size='medium' type='primary' @click='saveAuthor'>确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import '@/assets/css/system.css'
import request from '../../../utils/request.js'
import ViewRight from '../dialog/rightsDialog.vue'
import { post } from '@/api/requrestHttp'

export default {
  components: {
    ViewRight
  },
  data() {
    return {
      names: '',
      typeModallook: false,
      typeModal: false,
      rowid: '',
      showViewRight: false,
      dialogTitle: '新增',
      flag: 'add',
      showDialog: false,
      editDisable: false,
      rowData: {
        useable: '',
        enname: '',
        shengjiId: '',
        shijiId: '',
        qujiId: '',
        stationId: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入角色名',
            trigger: 'blur'
          }
        ],
        enname: [
          {
            required: true,
            message: '请输入英文字符，唯一',
            trigger: 'blur'
          },
          {
            validator: function(rule, value, callback) {
              //  校验英文的正则
              if (/[a-zA-z]$/.test(value) == false) {
                callback(new Error('请输入英文字符，唯一'))
              } else {
                //校验通过
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        useable: [{ required: true, message: '请选择状态', trigger: 'blur' }]
      },
      multipleSelection: [],
      searchlist: {
        shengjiId: '',
        shijiId: '',
        qujiId: '',
        stationId: ''
      },
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      // 授权数据弹框
      authorDialogVisible: false,
      selcetId: null,
      orgTree: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  methods: {
    getloign(id) {
      this.$http
        .request({
          url: '/admin/role/info/findUserRole',
          method: 'POST',
          data: {
            id: id
          }
        })
        .then((res) => {
          if (res.code === 200) {
            if (!res.content.id) {
              this.$message.error('该账号存在相关数据暂不可修改或删除')
              return false
            }
          }
        })
    },
    // 删除角色
    deleteItem(id, name) {
      if (name === 'admin') {
        this.$message({
          message: '禁止删除管理员账号',
          type: 'error'
        })
        return false
      }
      this.$http
        .request({
          url: '/rbac//admin/role/info/findUserRole',
          method: 'POST',
          data: { id }
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.content && res.content.length > 0) {
              this.$confirm('当前角色已关联公司, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(async () => {
                  let params = JSON.stringify({ id: id })
                  const { code, message } = await request({
                    url: '/rbac/admin/role/info/delete',
                    method: 'POST',
                    data: params
                  })
                  if (code === 200) {
                    this.$message.success('删除成功')
                    this.showDialog = false
                    this.pageConfig.pageNo = 1
                    this.getPageDatas()
                  } else {
                    this.$message.error(`删除失败:${message}`)
                  }
                })
                .catch(() => {
                  this.$message.info('已取消删除')
                })
            } else {
              this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(async () => {
                  let params = JSON.stringify({ id: id })
                  const { code, message } = await request({
                    url: '/rbac/admin/role/info/delete',
                    method: 'POST',
                    data: params
                  })
                  if (code === 200) {
                    this.$message.success('删除成功')
                    this.showDialog = false
                    this.pageConfig.pageNo = 1
                    this.getPageDatas()
                  } else {
                    this.$message.error(`删除失败:${message}`)
                  }
                })
                .catch(() => {
                  this.$message.info('已取消删除')
                })
            }
          } else if (res.code == '10004') {
            this.$message.error(res.message)
            this.$router.push('/login')
          }
        })
    },
    // 添加角色管理
    async addend() {
      if (this.rowData.name == '') {
        this.$message.error('角色名称不能为空')
        return false
      }
      const result = await post('/rbac/admin/role/info/insert', {
        data: this.rowData.name
      })
      console.log(111111111111111)
      console.log(result)
      if (code === 200) {
        this.tableData = result.content.list
      } else {
        this.$message.error(this.dialogTitle + '失败：' + message)
      }
    },
    // 保存授权数据
    async saveAuthor() {
      const orgIds = this.$refs.orgTree.getCheckedKeys()
      console.log(orgIds)
      const { code } = await post('/rbac/admin/role/info/saveRoleData', {
        id: this.selcetId,
        orgIds
      })
      if (code === 200) {
        this.$message.success('保存成功')
        this.onAuthorDialogClose()
      } else {
        this.$message.error('保存失败')
      }
    },
    // 授权数据弹框关闭
    onAuthorDialogClose() {
      this.selcetId = null
      this.authorDialogVisible = false
    },
    // 授权角色弹框显示
    async showAuthorDialog(id) {
      this.authorDialogVisible = true
      this.selcetId = id
      const { content } = await post('/rbac/admin/role/info/findRoleDataList', {
        id
      })
      this.$nextTick(() => {
        this.$refs.orgTree.setCheckedKeys(content || [], true)
      })
    },
    // 获取机构树
    async getOrgTree() {
      const { content } = await post('/rbac/admin/org/info/OrgTreelist', {
        isValid: 1
      })
      this.orgTree = content
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    searchlistReset() {
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getPageDatas()
    },
    //获取列表数据
    async getPageDatas() {
      this.searchlist.pageNo = this.pageConfig.pageNo
      this.searchlist.pageSize = this.pageConfig.pageSize
      this.searchlist.qujiId = JSON.parse(localStorage.getItem('czUserInfo')).qujiId
      this.searchlist.shengjiId = JSON.parse(
        localStorage.getItem('czUserInfo')
      ).shengjiId
      this.searchlist.shijiId = JSON.parse(localStorage.getItem('czUserInfo')).shijiId
      this.searchlist.stationId = JSON.parse(
        localStorage.getItem('czUserInfo')
      ).stationId
      let params = JSON.stringify(this.searchlist)
      const { code, content } = await request({
        url: '/rbac/admin/role/info/list',
        method: 'POST',
        data: params
      })
      if (code === 200) {
        if (content != null) {
          this.pageConfig.total = content.count
          this.tableData = content.list
        } else {
          this.pageConfig.total = 0
          this.tableData = []
        }
      } else {
        this.$message.error('数据加载异常')
      }
    },
    //删除操作
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    async deleteRows() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请先选择您要删除的数据项',
          type: 'error'
        })
        return
      }
      this.$confirm('此操作将删除您选中的数据项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let ids = []
          this.multipleSelection.forEach((item) => {
            ids.push(item.id)
          })
          let params = JSON.stringify({ ids: ids })
          const { code, message } = await request({
            url: '/rbac/admin/role/info/batchDeleteRole',
            method: 'POST',
            data: params
          })
          if (code === 200) {
            this.$message.success('删除成功')
            this.pageConfig.pageNo = 1
            this.getPageDatas()
          } else {
            this.$message.error(`删除失败:${message}`)
          }
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    //改变状态
    changeStatus(cdata) {
      this.$http
        .request({
          url: '/rbac/admin/role/info/findUserRole',
          method: 'POST',
          data: { id: cdata.id }
        })
        .then((res) => {
          if (res.code === 200) {
            let params = JSON.stringify(cdata)
            const { code, message } = request({
              url: '/rbac/admin/role/info/update',
              method: 'POST',
              data: params
            })
            let msg = '状态'
            msg = msg + (cdata.useable == '1' ? '启用' : '禁用')
            if (code === 200) {
              this.$message.success(`${msg}成功`)
            } else {
              console.log(12232)
              this.$message.error(`${msg}失败:${message}`)
            }
          } else {
            this.getPageDatas()
          }
        })
        .catch(() => {
          this.getPageDatas()
        })
    },

    async lookcenter(type, row) {
      this.typeModallook = true
      this.dialogTitle = type
      console.log(type, row, 78987667899)
      if (row) {
        this.names = row.name
      }
    },

    async showDialogForm(id, flag, name) {
      this.flag = flag
      if (flag === 'assign') {
        this.showViewRight = true
        this.showDialog = false
        this.rowid = id
        this.$nextTick(() => {
          //解决子组件数据无法刷新问题
          if (this.$refs.viewRight !== undefined) {
            this.$refs.viewRight.id = this.rowid
            this.$refs.viewRight.getData()
          }
        })
      } else {
        this.showViewRight = false
        if (id != '') {
          if (flag === 'edit') {
            this.editDisable = false
            this.dialogTitle = '编辑'
          } else if (flag === 'detail') {
            this.editDisable = true
            this.dialogTitle = '查看'
          }
          //获取编辑项的最新数据
          const { code, content } = await request({
            url: '/rbac/admin/role/info/findById',
            method: 'POST',
            data: { id }
          })
          if (code === 200) {
            this.rowData = content
            this.rowData.roleFeatures = Number(this.rowData.roleFeatures)
            this.showDialog = true
          } else {
            this.$message.error('数据项加载异常')
            this.showDialog = false
          }
        } else {
          this.editDisable = false
          this.showDialog = true
          this.dialogTitle = '新增'
          this.rowData = {
            useable: 1,
            roleFeatures: 1
          }
        }
      }
    },
    dialogReturn(data) {
      this.showViewRight = false
    },
    //获取新增所有数据发请求
    async saveadddata() {
      this.$refs.dialogfrom.validate(async (valid) => {
        if (valid) {
          this.rowData.qujiId = JSON.parse(localStorage.getItem('czUserInfo')).qujiId
          this.rowData.shengjiId = JSON.parse(
            localStorage.getItem('czUserInfo')
          ).shengjiId
          this.rowData.shijiId = JSON.parse(localStorage.getItem('czUserInfo')).shijiId
          this.rowData.stationId = JSON.parse(
            localStorage.getItem('czUserInfo')
          ).stationId
          let params = JSON.stringify(this.rowData)
          if (params == '{}') {
            this.$message({
              message: '保存数据为空',
              type: 'error'
            })
            return false
          }
          let url = '/rbac/admin/role/info/update'
          if (this.flag === 'add') {
            url = '/rbac/admin/role/info/insert'
          }
          const { code, message } = await request({
            url: url,
            method: 'POST',
            data: params
          })
          if (code === 200) {
            this.$message.success(this.dialogTitle + '成功')
            this.showDialog = false
            this.pageConfig.pageNo = 1
            this.getPageDatas()
          } else {
            this.$message.error(this.dialogTitle + '失败：' + message)
          }
        } else {
          this.$message.error('请按照规则重新输入')
          return false
        }
      })
    },
    // 新增弹出框重置
    clearadddata() {
      this.showDialog = false
    },
    //删除操作
    async showdeletepanduan(id, name) {
      if (name === 'admin') {
        this.$message({
          message: '禁止删除管理员账号',
          type: 'error'
        })
        return false
      }
      this.$http
        .request({
          url: '/rbac/admin/role/info/findUserRole',
          method: 'POST',
          data: { id }
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.content && res.content.length > 0) {
              this.$confirm('当前角色已关联公司, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(async () => {
                  let params = JSON.stringify({ id: id })
                  const { code, message } = await request({
                    url: '/rbac/admin/role/info/delete',
                    method: 'POST',
                    data: params
                  })
                  if (code === 200) {
                    this.$message.success('删除成功')
                    this.showDialog = false
                    this.pageConfig.pageNo = 1
                    this.getPageDatas()
                  } else {
                    this.$message.error(`删除失败:${message}`)
                  }
                })
                .catch(() => {
                  this.$message.info('已取消删除')
                })
            } else {
              this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(async () => {
                  let params = JSON.stringify({ id: id })
                  const { code, message } = await request({
                    url: '/rbac/admin/role/info/delete',
                    method: 'POST',
                    data: params
                  })
                  if (code === 200) {
                    this.$message.success('删除成功')
                    this.showDialog = false
                    this.pageConfig.pageNo = 1
                    this.getPageDatas()
                  } else {
                    this.$message.error(`删除失败:${message}`)
                  }
                })
                .catch(() => {
                  this.$message.info('已取消删除')
                })
            }
          }
          console.log(res)
        })
    }
  },
  mounted() {
    this.getPageDatas()
    this.getOrgTree()
  }
}
</script>
